import React, { FC, useCallback, useMemo } from 'react';
import { useField } from 'formik';
import { FormField, Label, Combobox, FormHelp } from '@zillow/constellation';
import { useListTagsQuery } from 'API/tags/TagApi';

const useGetTags = () => {
  const { data: tags = [] } = useListTagsQuery();

  return useMemo(
    () =>
      tags.map((tag) => ({
        label: tag.label,
        value: tag.id,
        id: tag.id,
      })),
    [tags]
  );
};

export const TagsFilter: FC = () => {
  const [field, meta, helpers] = useField<string>({ name: 'tag' });
  const tagOptions = useGetTags();

  const onChange = useCallback(
    (nextValue: any, constellationComboboxMeta: any) => {
      helpers.setValue(constellationComboboxMeta.option.value);
    },
    [helpers]
  );

  return (
    <FormField
      label={<Label>Tags</Label>}
      control={
        <Combobox
          value={field.value}
          options={tagOptions}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          showLabelForValue
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
